import { httpClient } from "../../httpClient";

export type AccessProvisioner = {
  referenceNumber: string;
  rfNo: string;
  userEmail: string;
  effectiveDate: string;
  systemType: string;
  requestType: number | string;
  requestor: string;
  category: string;
  subCategory: string;
  status: string;
  environment: string;
  encryptId?: string; // [TODO] Make not null when encrypt id gets included on /request/provisioners API response
};

export async function getProvisioners(): Promise<AccessProvisioner[]> {
  try {
    const { data } = await httpClient.get<{
      accessProvisioners: AccessProvisioner[];
    }>(`/api/v1/request/provisioners`);

    return data.accessProvisioners;
  } catch (error) {
    throw error;
  }
}


export async function getRequestForAccessProvisionerPaginated(
  page: number,
  perPage: number,
  searchQuery: string,
  sortItem: string,
  sortBy: string,
  isApproved: boolean,
  isInProgress: boolean,
  isCompleted: boolean,
  isRejected: boolean,
  isRFDeclined: boolean,
  isUserDeclinedAssesstation: boolean
) {
  try {
    const { data } = await httpClient.get(
      `/api/v1/request/accessprovisionerspager/${page}/${perPage}/${sortItem}/${sortBy}/${isApproved}/${isInProgress}/${isCompleted}/${isRejected}/${isRFDeclined}/${isUserDeclinedAssesstation}/search?query=${searchQuery}`
    );
    return data;
  } catch (error) {
    throw error;
  }
}